import React from 'react'
import VideoPlayButton from '@components/Icons/VideoPlayButton'
import ResponsiveImage from '@components/ResponsiveImage'

type StringOrBoolean = string | boolean

interface VideoCoverProperties {
  id: string
  src: string
  altText: string
  ariaLabel: string
  showPlayButton?: boolean
  onClick: () => void
  shouldLazyLoad?: StringOrBoolean
  fetchPriorityHigh?: boolean
  buttonAriaLabel?: string
}

const VideoCover: React.FC<VideoCoverProperties> = ({
  id,
  src,
  altText,
  ariaLabel,
  showPlayButton = true,
  onClick,
  shouldLazyLoad,
  fetchPriorityHigh,
  buttonAriaLabel,
}: VideoCoverProperties): JSX.Element => {
  return (
    <div className="cmp-video__cover" id={id}>
      {(src && (
        <ResponsiveImage
          aria-label={ariaLabel}
          className="cmp-video__image"
          src={src}
          alt={altText}
          shouldLazyLoad={shouldLazyLoad}
          fetchPriorityHigh={fetchPriorityHigh}
        />
      )) ||
        null}
      {showPlayButton && (
        <button className="cmp-video__button" aria-label={buttonAriaLabel} onClick={onClick}>
          <VideoPlayButton />
        </button>
      )}
    </div>
  )
}

export default VideoCover
